<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MeetingRoomBookingListing ref="meetingRoomBookingListing" />
        <MeetingRoomListing @saved="$refs.meetingRoomBookingListing.refreshListing()" />
</Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MeetingRoomBookingListing from "@/views/pages/ihextar/meetingRoomBooking/meetingRoomBookingListing";
import MeetingRoomListing from "@/views/pages/ihextar/meetingRoomBooking/meetingRoomListing";

export default {
    page: {
        title: i18n.t("module.roomBooking"),
    },
    components: { Layout, PageHeader, MeetingRoomListing, MeetingRoomBookingListing },
    data() {
        return {
            title: i18n.t("module.roomBooking"),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.roomBooking"),
                    active: true,
                },
            ],
        };
    },
}
</script>
